export const styles = (theme) => ({
  imglogo: {
    width: "45px",
    verticalAlign: "middle",
    marginRight: "14px",
    marginLeft: "10px",
    padding: "8px",
  },
  headingTxt: {
    position: "absolute",
    left: "-100000px",
  },

  player: {
    background: "#181818",
    padding: "0",
    "& div": {
      margin: "0 !important",
    },
  },
  trackName: {
    fontSize: "12px",
    textAlign: "center",
    color: "#00d056",
  },
  orgLogo: {
    marginTop: "15px",
    textAlign: "center",
    marginRight: "20px",
  },
  langArea: {
    marginTop: "18px",
    textAlign: "center",
    "& > div": {
      borderRadius: "3px",
      width: "auto",
      display: "inline-block",
      padding: " 0 10px",
      fontSize: "12px",
    },
  },
  playerHeader:{
    display:"flex",
    width:"100%",
  },
  headerLogoContainer:{
    display:"inline-block",
  },
  headerExpandableButton:{
    background: "#00ADAB",
    width: "10px !important",
    minWidth: "inherit",
    padding: "31px 2px 30px 2px",
     fontSize:"1em",
    position:"absolute",
    right:"-9px",
  },
  headerObjects:{
    display:"flex",
    alignItems: "center",
    justifyContent: "flex-end",
    margin:"14px",
    position:"relative"
  },
  orgLogo:{
    "& img":{
      width:"100px",
      height:"auto",
      display: "flex",
    },
  
  },
  orgFlexed:{
    display:"flex",
    alignItems:"center",
    color:"#fff",
    "& .MuiAvatar-square":{
    background:"none",
    minWidth:"100px",
    marginRight:"10px",
    },
    "& svg":{
      fontSize: "18px",
      margin:" 0 5px",
    }

  },
  dropOrgMenu:{
    "& .MuiMenu-list":{
      maxWidth:"275px",
      paddingBottom:"0"
    },
  },
  orgList:{
      padding:"6px 12px !important",
      border:"1px solid #4b4b4b",
      margin:"2px 11px 5px 11px !important",
      borderRadius:"4px",
      width:"45.3%",
      display:"inline-block",
      verticalAlign:"middle",
      margin:"0 4px 10px 7px !important",
      maxWidth:"125px",
      minWidth:"120px",
      "& a":{
        display:"block",
        textAlign:"center",
      },
      "& .MuiAvatar-square":{
        background:"none",
        minWidth:"100px",
        marginRight:"0px",
        },
  },  
  orgButton:{
    border:"1px solid #464646",
    padding:"5px",
    minHeight:"37px"
  },
  orgName:{
    fontSize:"11px",
    textTransform:"none",
    display: "block",
    fontSize: "10px",
    color: "#ccc",
  }
});
